import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-survey',
    templateUrl: './survey.component.html',
    styles: [],
})
export class SurveyComponent implements OnInit {
    constructor(private activatedRoute: ActivatedRoute) {}

    tempItems = [];

    items = [];

    totalItems = this.items.length;

    ngOnInit(): void {
        this.routeData();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.items = data.data;
            this.tempItems = data.data;
        });
    }
}
